import React, { useState, useEffect } from 'react'
import { useHistory, withRouter } from "react-router-dom";
import {
    Modal,
    Select,
    Form,
    Row,
    Col,
    Typography,
    message,
    Button,
} from "antd";
import { platformApi } from "../../../../api";
import './index.less'

const { Text, Title } = Typography;
const { Option } = Select;

const VehicleInspection = ({
    form,
    open,
    close,
    data,
    editData,
    editable,
    modify,
}) => {
    const history = useHistory();
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
    const [error, setError] = useState({});
    const [status, setStatus] = useState("")
    const [loading, setLoading] = useState(false);
    const StatusType = [
        { key: "Ready for Delivery", title: "Ready for Delivery" },
        { key: "Pending", title: "Pending" },
        { key: "Network Needed", title: "Network Needed" }
    ];

    //Edit Data
    useEffect(() => {
        if (data) {
            console.log("editData", data)
        }

    }, [data]);
    const handleStatus = (event) => {
        setStatus(event)
        setFieldsValue({
            status: event
        })
    }
    const handleSubmit = () => {
        console.log("handleSubmit called, editable:", editable, "modify:", modify);
        form.validateFields(async (validationError) => {
            if (validationError === null) {
                if (!data || !data.id) {
                    message.error("Invalid job order data", 2);
                    console.error("Data is undefined or missing id:", data);
                    return;
                }
                
                setLoading(true);
                const jobId = data.id; // Store ID to avoid undefined issues
                console.log("submit", jobId, getFieldValue("status"), status)
                
                // Increase timeout to 30 seconds for slow API
                const timeoutPromise = new Promise((_, reject) => 
                    setTimeout(() => reject(new Error('Request timeout')), 30000) // 30 second timeout
                );
                
                try {
                    const response = await Promise.race([
                        platformApi.put(`/api/jobOrder/setMech/${jobId}`, {
                            status: getFieldValue("status") ? getFieldValue("status") : status
                        }),
                        timeoutPromise
                    ]);
                    
                    console.log("API Response received:", response);
                    
                    if (!response || !response.data) {
                        throw new Error("Invalid response from server");
                    }
                    
                    let { data: responseData } = response;
                    if (responseData.code === 200) {
                        let { response: responseInner } = responseData;
                        if (responseInner && responseInner.code === 200) {
                            message.success("Job Order Updated successfully", 2);
                            close();
                        } else {
                            message.error("Unable to update Job Order", 2);
                        }
                    } else {
                        message.error("Unable to update Job Order", 2);
                    }
                } catch (err) {
                    console.error("Error on Job Order : ", err);
                    if (err.message === 'Request timeout') {
                        message.error("Request timed out. Please try again.", 3);
                    } else {
                        message.error(`Unable to update Job Order: ${err.message}`, 2);
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                console.log("Form validation failed:", validationError);
                message.error("Please fill in all required fields", 2);
            }
        });
    };
    const clearFieldsAndClose = () => {
        form.resetFields();
        close();
        history.push('/autoadmin/job_order');
    };
    return (
        <Modal
            title={<Title level={4}>Vehicle Inspection</Title>}
            visible={open}
            onCancel={clearFieldsAndClose}
            okText={!editable ? "Modify" : "Save"}
            okButtonProps={{ 
                disabled: (!editable && !modify) || loading,
                loading: loading && editable
            }}
            onOk={() => {
                console.log("Modal onOk clicked, editable:", editable);
                if (!editable) {
                    setEditable(true);
                } else {
                    handleSubmit();
                }
            }}
        >
            <Form className="purchase-form">
                <Row>
                    <Col span={12}>
                        <Text strong>
                            JOB NO&nbsp;&nbsp;&nbsp;: {data && data.jobNo}
                        </Text>
                    </Col>
                </Row>
                <Row type="flex" justify="space-between">
                    <Col span={24}>
                        <Form.Item
                            className="purchase-form-element"
                            colon={false}
                            required
                            validateStatus={error.STATUS && error.STATUS.type}
                            help={error.STATUS && error.STATUS.message}
                            label={<Text>Status</Text>}
                        >
                            {getFieldDecorator("status", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Status",
                                    },
                                ],
                            })(
                                <Select
                                    dropdownStyle={{
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                    }}
                                    onChange={(event) => {
                                        handleStatus(event)
                                    }}
                                    showSearch
                                    showAction={["click", "focus"]}
                                    disabled={!editable}
                                    placeholder="Status"
                                >
                                    {StatusType.map((item) => (
                                        <Select.Option key={item.key} value={item.title}>
                                            {item.title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

const WrappedVehicleInspection = Form.create("vehicle_inspection")(
    VehicleInspection
);

export default WrappedVehicleInspection;